export default __webpack_public_path__ + "i18n/translations/translation-nb.c40f7f7c.json";